/**
 * @desc 获取ebs当天汇率
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ExchangeRateBodyItem>>;
export function request(
  params: API.basics.exchangeRateFacadeImpl.getTodayEbsExchangeRate.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/basics/getTodayExchangeRate`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
